module.exports = __webpack_public_path__ + "img/ScanQREN.5b99854f.png";